module.exports = __webpack_public_path__ + "img/subject_banner12.726bb18a.png";